import { connect } from "react-redux";
import { RootState } from "types/store";

import CallPage from "./CallsPage";

const mapState = ({ calls }: RootState) => ({
    initFilters: calls.filters
});

export default connect(mapState)(CallPage); 